/**
 * Vue 3 migration note:
 * vue-i18n 8 (`new VueI18n()` + `Vue.use`) -> vue-i18n 9 (`createI18n()`).
 * We keep Options API mode (`legacy: true`) so existing `$t(...)` usage and the
 * `this.$i18n.locale = x` assignments (see store `changeLocale`) keep working
 * without touching every component. `require.context` is preserved because we
 * stay on Vue CLI 5 / webpack.
 */
import { createI18n } from 'vue-i18n'
import { dateTimeFormats } from '@/locales/formats/dataTimeFormats'

export function loadLocaleMessages() {
	const locales = (require as any).context(
		'@/locales',
		true,
		/[A-Za-z0-9-_,\s]+\.json$/i
	)
	const messages: Record<string, any> = {}
	locales.keys().forEach((key: string) => {
		const matched = key.match(/([A-Za-z0-9-_]+)\./i)
		if (matched && matched.length > 1) {
			const locale = matched[1]
			messages[locale] = locales(key)
		}
	})
	return messages
}

export function checkDefaultLanguage() {
	let matched = ''
	const languages = Object.getOwnPropertyNames(loadLocaleMessages())
	languages.forEach((lang) => {
		if (lang === navigator.language) {
			matched = lang
		}
	})
	if (!matched) {
		languages.forEach((lang) => {
			const languagePartials = navigator.language.split('-')[0]
			if (lang === languagePartials) {
				matched = lang
			}
		})
	}
	if (!matched) {
		languages.forEach((lang) => {
			const languagePartials = navigator.language.split('-')[0]
			if (lang.split('-')[0] === languagePartials) {
				matched = lang
			}
		})
	}
	return matched
}

export const languages = Object.getOwnPropertyNames(loadLocaleMessages())
export const selectedLocale =
	checkDefaultLanguage() || process.env.VUE_APP_I18N_LOCALE || 'English'

export default createI18n({
	// legacy: true keeps the Vue 2 Options API ($t, this.$i18n.locale, etc.)
	legacy: true,
	globalInjection: true,
	locale: selectedLocale,
	fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'English',
	messages: loadLocaleMessages(),
	datetimeFormats: dateTimeFormats as any,
})
